import React from 'react';
import { connect } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import { Button } from '@material-ui/core';
import I18n from '../../../config/locales';
import settings from '../../../utils/settings';
import analytics from '../../../utils/analytics';
import { get } from '../../../utils/lodash';
import clsx from 'clsx';
import { getToken } from '../../../utils/helper';
import feature from '../../../utils/feature';

const useStyles = makeStyles(theme => ({
  viewFullListWrapper: {
    textAlign: 'center',
    width: '100%',
    border: '1px solid #2679f6',
    color: '#2679f6',
    textTransform: 'capitalize'
  },
  addNewSystemButton: {
    marginLeft: 'auto',
    border: '1px solid #2679f6',
    color: '#2679f6',
    marginTop: theme.spacing(0.75),
    marginBottom: theme.spacing(0.625),
    textTransform: 'capitalize'
  }
}));

const SystemHeaderFooter = props => {
  const manager_token = getToken()
  const { companyId, fromITK, accountData } = props;

  const isSelfInstaller = get(accountData, 'self_installer', false)
  const enableNewActivationOnly = feature.isFeatureEnabled('ENABLE_NEW_ACTIVATION_ONLY')
  const isActivationenalbed = feature.isFeatureEnabled('ACTIVATION_WEB_FEATURE') || isSelfInstaller

  const classes = useStyles();
  const gaAnalytics = new analytics();
  const viewAllUrl = props.viewAllUrl || settings.enlightenMenuUrl('systems');
  const trackEventSystemFooter = () => {
    const dataLayer = {
      viewAddValue: 'View All'
    };
    gaAnalytics.triggerEvent({ event: 'triggerViewAddSystems' }, dataLayer);
  };
  const addNewText = props.isLead ? `+ ${I18n.t('dashboard.createNewLead')}` : `+ ${I18n.t('dashboard.addNewSystems')}`;
  const addNewUrl = props.isLead
    ? settings.enlightenMenuUrl(`manager/dashboard/${companyId}/leads/create-lead`)
    : (isActivationenalbed && (props.accountData?.preferred_new_activation_view === null || props.accountData?.preferred_new_activation_view)) || enableNewActivationOnly ? settings.enlightenMenuUrl(`manager/dashboard/activations?fromEnlighten=${true}`) : settings.enlightenMenuUrl('activations/new')
  const handleView = url => {
    trackEventSystemFooter();
    window.open(url, '_blank');
  };
  const handleAdd = url => {
    const dataLayer = {
      menuValue: props.isLead ? 'Create New Lead' : 'Add New System'
    };
    gaAnalytics.triggerEvent({ event: 'triggerSystemBox' }, dataLayer);
    window.open(url, '_blank');
  };
  if (props.footer) {
    return (
      <Button
        className={classes.viewFullListWrapper}
        onClick={() => {
          handleView(viewAllUrl);
        }}
      >
        {I18n.t('dashboard.viewFullList')}
      </Button>
    );
  } else if (!props.viewOnlyAccess && (props.isLead || !fromITK)) {
    return (
      <Button
        className={clsx(classes.addNewSystemButton)}
        onClick={() => {
          handleAdd(addNewUrl);
        }}
      >
        {addNewText}
      </Button>
    );
  }
  return null;
};

const mapStateToProps = state => ({
  companyId: state.appReducer.companyId,
  viewOnlyAccess: state.accountReducer.viewOnlyAccess,
  fromITK: state.appReducer.fromITK,
  accountData: state.accountReducer.accountDetail,
});

export default connect(mapStateToProps)(SystemHeaderFooter);
